.optionDataIcon {
  position: relative;
  font-size: 2.3rem;
  margin-top: -3px;
}
